import React from 'react';

interface GameContainerProps {
  children: React.ReactNode;
  title: string;
  onBack: () => void;
  icon?: string;
  subtitle?: string;
}

const DECOR = [
  { s: '⭐', c: 'top-3 left-4 text-2xl', d: '0s' },
  { s: '✨', c: 'top-10 right-6 text-xl', d: '1.2s' },
  { s: '🎈', c: 'bottom-6 left-3 text-2xl', d: '2.1s' },
  { s: '☁️', c: 'top-2 right-1/4 text-3xl', d: '0.6s' },
  { s: '🌟', c: 'bottom-10 right-4 text-xl', d: '3s' },
];

const GameContainer: React.FC<GameContainerProps> = ({ children, title, onBack, icon, subtitle }) => (
  <div className="relative w-full max-w-4xl mx-auto">
    <button
      onClick={onBack}
      className="mb-4 inline-flex items-center gap-1.5 text-sm font-bold text-white bg-gradient-to-r from-violet-500 to-fuchsia-500 rounded-full px-4 py-1.5 shadow-md hover:scale-105 hover:shadow-lg transition-transform"
    >
      <span aria-hidden="true">&larr;</span> Back to Games
    </button>
    <div className="fun-frame relative overflow-hidden p-4 md:p-6 rounded-3xl shadow-xl border-4 border-white bg-gradient-to-br from-sky-100 via-fuchsia-50 to-amber-100">
      {DECOR.map((d, i) => (
        <span key={i} className={`fun-float absolute opacity-40 pointer-events-none select-none ${d.c}`} style={{ animationDelay: d.d }} aria-hidden="true">{d.s}</span>
      ))}
      <div className="relative z-10">
        <div className="text-center mb-4">
          <h2 className="text-2xl md:text-3xl font-black flex items-center justify-center gap-3">
            {icon && <span className="fun-bounce inline-flex w-12 h-12 items-center justify-center rounded-2xl bg-white shadow-md text-3xl" aria-hidden="true">{icon}</span>}
            <span className="bg-gradient-to-r from-violet-600 via-fuchsia-500 to-orange-500 bg-clip-text text-transparent">{title}</span>
          </h2>
          {subtitle && <p className="text-sm font-medium text-gray-600 mt-1">{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  </div>
);

export default GameContainer;
